"use strict";
// Class definition
import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules"
import SwiperAnimation from '@cycjimmy/swiper-animation';
import {Modal} from 'bootstrap';
import Cookies from 'js-cookie'
import {gsap} from "gsap";

var App = function () {
    let swiperAnimation;
    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Autoplay]);
        swiperAnimation = new SwiperAnimation();
    }
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined;
    }

    const MainSlider = () => {
        var interleaveOffset = 0.5;
        let nextSliderTimeout;
        let home_slider;

        let videos = document.querySelectorAll('.home-slider .swiper-slide video');
        videos.forEach(function ($el) {
            let ths = $el;
            let load = setInterval(function () {
                if (ths.readyState >= 1) {
                    let duration = (ths.duration * 1000) - 1000
                    if (duration > 0) {
                        ths.closest(".swiper-slide").setAttribute('data-swiper-autoplay', duration);
                    }
                    clearInterval(load);
                }
            }, 100)
        });


        let youtubeVideos = document.querySelectorAll('.home-slider .video-wrapper .youtube-video');

        function updateNextSliderPreview(swiper) {
            const nextSlider = document.querySelector('.next-slider');
            if (!nextSlider) return;

            clearTimeout(nextSliderTimeout);
            nextSlider.style.transform = 'scale(0)';

            const nextIndex = swiper.activeIndex + 1;
            if (nextIndex >= swiper.slides.length) return;

            const nextSlide = swiper.slides[nextIndex];
            const nextImage = nextSlide.getAttribute('data-image');
            const nextTitle = nextSlide.getAttribute('data-title');

            nextSliderTimeout = setTimeout(() => {
                nextSlider.querySelector('img').src = nextImage;
                nextSlider.querySelector('.title').textContent = nextTitle;
                nextSlider.style.transform = 'scale(1)';
            }, 2000);
        }

        setTimeout(function () {
            home_slider = new Swiper('.home-slider', {
                loop: false,
                speed: 1000,
                grabCursor: true,
                watchSlidesProgress: true,
                mousewheelControl: true,
                keyboardControl: true,
                init: (youtubeVideos.length <= 0),
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                on: {
                    progress: function (swiper, progress) {
                        for (var i = 0; i < swiper.slides.length; i++) {
                            var slideProgress = swiper.slides[i].progress;
                            var innerOffset = swiper.width * interleaveOffset;
                            var innerTranslate = slideProgress * innerOffset;
                            if (swiper.slides[i].querySelector(".slide-background"))
                                swiper.slides[i].querySelector(".slide-background").style.transform =
                                    "translate3d(" + innerTranslate + "px, 0, 0)";
                        }
                    },
                    touchStart: function () {
                        var swiper = this;
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = "";
                        }
                    },
                    setTransition: function (swiper, speed) {
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = speed + "ms";
                            if (swiper.slides[i].querySelector(".slide-background"))
                                swiper.slides[i].querySelector(".slide-background").style.transition =
                                    speed + "ms";
                        }
                    },
                    init: function (swiper) {
                        swiperAnimation.init(this).animate();

                        var currentVideo = $(swiper.slides[this.activeIndex]).find("video");
                        currentVideo.trigger('play');

                        updateNextSliderPreview(swiper);
                    },
                    slideChangeTransitionStart: function () {
                        // Slayt değiştiği an kutuyu hemen kapat
                        const nextSlider = document.querySelector('.next-slider');
                        if (nextSlider) nextSlider.style.transform = 'scale(0)';
                        clearTimeout(nextSliderTimeout);
                    },
                    slideChange: function (swiper) {
                        swiperAnimation.init(this).animate();

                        videos.forEach(function (ths) {
                            ths.currentTime = 0;
                        });
                        var prevVideo = $(swiper.slides[this.previousIndex]).find("video");
                        var currentVideo = $(swiper.slides[this.activeIndex]).find("video");
                        prevVideo.trigger('stop');
                        currentVideo.trigger('play');

                    },
                    slideChangeTransitionEnd: function (swiper) {
                        updateNextSliderPreview(swiper);

                        videos.forEach(v => {
                            v.currentTime = 0;
                        });
                        $(swiper.slides).find("video").trigger('stop');
                        $(swiper.slides[swiper.activeIndex]).find("video").trigger('play');
                    }
                }
            });
            const nextSliderBtn = document.querySelector('.next-slider');
            if (nextSliderBtn) {
                nextSliderBtn.addEventListener('click', function () {
                    home_slider.slideNext();
                });
            }
        }, 500);

        if (youtubeVideos) {
            youtubeVideos.forEach((youtubeVideo) => {
                const player = new YouTubePlayer(youtubeVideo, {
                    related: false,
                    fullscreen: true,
                    keyboard: false,
                    modestBranding: true,
                    controls: false,
                    annotations: false,
                });
                player.mute();
                player.load(youtubeVideo.dataset.videoId, ["autoplay"]);

                let swiperSlide = youtubeVideo.parentElement.parentElement.parentElement;
                let firstPlaying = true;
                player.on('playing', async () => {
                    let duration = await player.getDuration() * 1000;
                    if (duration > 0) {
                        await swiperSlide.setAttribute('data-swiper-autoplay', duration);

                        setTimeout(() => {
                            home_slider.init();
                        }, 700)

                        if (firstPlaying) {
                            player.stop();
                            firstPlaying = false;
                            player.play();
                        }

                        setTimeout(() => {
                            home_slider.on('slideChange', function () {
                                // find the current slide
                                let currentSlide = home_slider.slides[home_slider.activeIndex];
                                let prevSlide = home_slider.slides[home_slider.previousIndex];

                                if (prevSlide.querySelector('.youtube-video')) {
                                    player.pause();
                                }

                                if (currentSlide.querySelector('.youtube-video')) {
                                    const progressFill = document.querySelector('.progress-bar .fill');
                                    progressFill.style.animationDuration = (duration) + 's';
                                    player.play();
                                }
                            })
                        }, 700)
                    }
                })
            })
        }
    }

    const slides = () => {
        new Swiper('.showcase-products .swiper', {
            slidesPerView: 5,
            spaceBetween: 20,
            breakpoints: {
                0: {
                    slidesPerView: 2
                },
                576: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 4
                },
                992: {
                    slidesPerView: 5
                },
                1200: {
                    slidesPerView: 6
                },
                1600: {
                    slidesPerView: 5,
                    spaceBetween: 39
                }
            }
        })

        new Swiper('.showcase-projects .swiper', {
            slidesPerView: 3.8,
            spaceBetween: 33,
            loop: true,
            navigation: {
                nextEl: '.showcase-projects .swiper-next',
                prevEl: '.showcase-projects .swiper-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.2
                },
                576: {
                    slidesPerView: 2.6
                },
                768: {
                    slidesPerView: 3.2
                },
                992: {
                    slidesPerView: 3.8
                }
            }
        })

        new Swiper('.water-into-art .swiper', {
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
        })

        new Swiper('.showcase-blogs .swiper', {
            slidesPerView: 4,
            spaceBetween: 15,
            loop: true,
            navigation: {
                nextEl: '.showcase-blogs .swiper-next',
                prevEl: '.showcase-blogs .swiper-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                660: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 4
                },
                1200: {
                    spaceBetween: 33
                }
            }
        })

        document.querySelector('.menu-btn').addEventListener('click', (el) => {
            document.body.classList.add('cvz-menu-open');
            // gsap.to(".cvz-menu-preload-bg.bg-1", {x: "0%", ease: "Power4.easeInOut"});
            gsap.to(".cvz-menu", {x: "0%", ease: "Power4.easeInOut"});
        })

        document.querySelector('.cvz-menu .close-btn').addEventListener('click', () => {
            document.body.classList.remove('cvz-menu-open');
            gsap.to(".cvz-menu", {x: "100%", ease: "Power4.easeInOut"});
            // gsap.to(".cvz-menu-preload-bg.bg-1", {x: "100%", ease: "Power4.easeInOut"});
        })

        document.querySelectorAll('.group-item').forEach(function (el) {
            let title = el.querySelector('.title');
            title.style.width = title.getBoundingClientRect().width + 'px';
        })
    }

    return {
        init: function () {
            swiperUse();
            MainSlider();
            slides();
        },
    };
}();

// On document ready
jQuery(document).ready(function () {
    App.init();
});